module.exports = __webpack_public_path__ + "img/omg.50f14ac2.svg";